module.exports = __webpack_public_path__ + "img/expense.f60aa18f.png";